import './index-metric-ops.style.scss'

class indexMetricOpsController {

}

export default indexMetricOpsController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-ops/index-metric-ops.controller.js